module.exports = {
  configureWebpack: {
    devtool: 'source-map'
  },

  pages: {
    index: {
      entry: 'src/main.js',
      template: 'src/index.html',
      title: "Grundbuchblätter"
    }
  },
  runtimeCompiler: true,

  publicPath: process.env.NODE_ENV === 'production'
    ? '/r/grundbuchblaetter'
    : '/',

  devServer: {
    overlay: {
      warnings: true,
      errors: true
    }
  },

  lintOnSave: process.env.NODE_ENV !== 'production',

  pluginOptions: {
    i18n: {
      locale: 'de',
      fallbackLocale: 'de',
      localeDir: 'locales',
      enableInSFC: false
    }
  }
}
